import { format, parse } from "date-fns"
import DOMPurify from "dompurify"
import React from "react"

import { dmy_dateFormat, eur_dateFormat, IMAGE_NOT_AVAILABLE, iso_dateFormat, jul_dateFormat, LOCATION_HOST, mdy_dateFormat, OPS_SAS_TOKEN, QA_SAS_TOKEN, UAT_SAS_TOKEN, usa_dateFormat, ymd_dateFormat } from "./Constant"
import menu from "./menuConfig.json"
import messageCodes from "./messageCodes.json"
import { PART_NO_IMAGE_URL, SAMPLE_COLLECTION_IMAGE_URL, TYPE_NO_IMAGE_URL } from "../config"
const convertDate = (isoTimestamp) => {
    if (!isoTimestamp) {
        return isoTimestamp
    }
    const utcDate = new Date(isoTimestamp)
    const localDate = new Date(
        utcDate.getTime() + utcDate.getTimezoneOffset() * 60000
    ) // Adjust for local time zone
    const formattedDate = format(localDate, "yyyy/MM/dd ")
    return formattedDate
}

const formatDate = (date) => {
    const formattedDate = format(date, "yyyy/MM/dd ")
    return formattedDate
}

const parseDate = (isoTimestamp) => {
    if (!isoTimestamp) return ""
    const formats = [
        "yyyyMMdd",         // 20121231
        "yyyy-MM-dd",       // 2012-12-31
        "yyyy/MM/dd",       // 2012/12/31
        "yyyy.MM.dd",       // 2012.12.31
        "dd-MM-yyyy",       // 31-12-2019
        "yyyy-MM-dd'T'HH:mm:ssX" // 2012-12-31T00:00:00Z
    ]
    let parsedDate = null
    for (const fmt of formats) {
        try {
            parsedDate = parse(isoTimestamp, fmt, new Date())
            if (!isNaN(parsedDate)) break
        } catch (error) {
            continue
        }
    }
    if (!parsedDate || isNaN(parsedDate)) {
        return isoTimestamp // Return as-is if parsing fails
    }
    return format(parsedDate, "MMM,dd,yyyy") // Output format e.g., "Jan, 04, 2025"
}

const convertDateTime = (isoTimestamp) => {
    if (!isoTimestamp) {
        return isoTimestamp
    }
    const utcDate = new Date(isoTimestamp)
    /* const localDate = new Date(
        utcDate.getTime() + utcDate.getTimezoneOffset() * 60000
    ) // Adjust for local time zone*/
    const formattedDateTime = format(utcDate, "yyyy/MM/dd 'at' HH:mm")
    return formattedDateTime
}

const textLineClamp = (text, widthSelector) => {
    return <p className={ `line-clamp-2 text-ellipsis overflow-hidden white-space:nowrap  ${widthSelector ? widthSelector : "min-w-40"}` }>{ text }</p>
}

const convertDateToDDMMYYYY = (isoTimestamp) => {
    if (!isoTimestamp) {
        return isoTimestamp
    }
    const utcDate = new Date(isoTimestamp)
    const localDate = new Date(
        utcDate.getTime() + utcDate.getTimezoneOffset() * 60000
    ) // Adjust for local time zone
    const formattedDateTime = format(localDate, "dd/MM/yyyy")
    return formattedDateTime
}

const getLocalDate = (isoTimestamp) => {
    if (!isoTimestamp) {
        return isoTimestamp
    }
    const utcDate = new Date(isoTimestamp)
    const localDate = new Date(
        utcDate.getTime() + utcDate.getTimezoneOffset() * 60000
    )
    return localDate
}

const capitalizeFirstLetter = (string) => {
    if (typeof string !== "string" || string?.length === 0) {
        return ""
    }
    return string.charAt(0).toUpperCase() + string.slice(1)
}

// Input we can expect "string,string or only string"
const capitalizeEachLetter = (string) => {
    const stringtoArray = string.split(",")
    const strings = stringtoArray.map((string) => {
        return capitalizeFirstLetter(string)
    })
    return strings.toString()
}

const getActivityIdByPathname = (pathName) => {
    return menu?.filter((key) => {
        if (key.path === pathName || pathName?.startsWith(key.path)) {
            return key.activity_id
        }
    })
}

const getTranslateByPathname = (pathName) => {
    return menu?.filter((key) => {
        if (key.path === pathName) {
            return key.translate
        }
    })
}

const getUploadByPathname = (pathName) => {
    return menu?.filter((key) => {
        if (key.path === pathName) {
            return key.upload
        }
    })
}

const getUserDetails = () => {
    const userDetails = sessionStorage.getItem("userDetails")
    if (userDetails) {
        const parsedDetails = JSON.parse(userDetails)
        const { first_name, last_name, user_name } = parsedDetails?.user_details || {}
        if (first_name !== null && last_name !== null) {
            return `${first_name} ${last_name}`
        } else {
            return user_name
        }

    }
    return ""
}

const orderCheckInFunction = () => {
    const loginDetails = sessionStorage.getItem("userDetails")
    if (loginDetails) {
        const loggedInUserDetails = loginDetails
            ? JSON.parse(loginDetails)?.user_details
            : {}
        let orderCheck = loggedInUserDetails?.service_center_details?.filter((orderItem ) => { return orderItem?.function?.includes("order") })
        if (loggedInUserDetails && loggedInUserDetails?.service_center_details?.length > 0 && orderCheck?.length > 0) {
            return true
        }
        else if (loggedInUserDetails && loggedInUserDetails?.salesOrgs?.length > 0) {
            return true
        }
        else {
            return false
        }
    }
}

const getUserServiceCenterDetails = () => {
    const userDetails = sessionStorage.getItem("userDetails")
    if (userDetails) {
        const loggedInUserDetails = userDetails
            ? JSON.parse(userDetails)?.user_details
            : {}
        return loggedInUserDetails?.service_center_details[0]
    }
}

const getUserFunctionsArray = () => {
    const userFunctionsArray = getUserServiceCenterDetails?.function?.split(",")
    return userFunctionsArray
}

const getInternalUser = () => {
    const userDetails = sessionStorage.getItem("userDetails")
    if (userDetails) {
        const parsedDetails = JSON.parse(userDetails)
        const { user_type } = parsedDetails?.user_details || {}
        if (user_type !== null) {
            let interExternalUser = user_type === 1 ? false : true
            return interExternalUser
        }
    }
    return ""
}
const scrollToError = (formData) => {
    let firstErrorElement = null
    Object.keys(formData).forEach((fieldName) => {
        const element = document.querySelector(`[name="${fieldName}"]`)
        // Check if the element is a valid DOM element
        if (element && typeof element.scrollIntoView === "function") {
            const isError = formData[fieldName] === "" // Replace with your error condition        
            if (isError && element.type === "hidden") {
                const nearestVisibleElement = element.closest("label, div, span, p")
                if (nearestVisibleElement && !firstErrorElement) {
                    firstErrorElement = nearestVisibleElement
                }
            }
            else if (isError && !firstErrorElement) {
                firstErrorElement = element
            }
        }
    })
    if (firstErrorElement) {
        firstErrorElement.scrollIntoView({ behavior: "smooth", block: "center" })
        firstErrorElement.focus()
    }
}

const buildErrorMessage = (message, replaceContext = []) => {
    for (let i = 0; i < replaceContext.length; i++) {
        message = message.replaceAll(`{${i}}`, replaceContext[i])
    }
    return message
}

const sortData = (a, b, id) => {
    const valueA = a.values[id]
    const valueB = b.values[id]

    const numA = parseFloat(valueA)
    const numB = parseFloat(valueB)
    if (!isNaN(numA) && !isNaN(numB)) {
        return numA > numB ? 1 : -1
    }

    const alphaNumA = valueA?.toString()
    const alphaNumB = valueB?.toString()
    return alphaNumA?.localeCompare(alphaNumB, undefined, { numeric: true })
}

const isValidURL = url => {
    const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i
    return urlPattern.test(url)
}


// convert rich text to text
const extractPlainText = (input) => {
    if (!input) {
        return "" // Handle null or undefined input
    }
    // Check if the input is already plain text (not JSON)
    try {
        const parsedData = JSON.parse(input)
        // If parsing is successful, traverse the JSON structure
        let plainText = ""
        const traverse = (node) => {
            if (typeof node === "string") {
                plainText += node
            } else if (node?.children && Array.isArray(node.children)) {
                node.children.forEach(traverse)
            } else if (node?.text) {
                plainText += node.text // Handle nodes that contain text
            }
        }
        traverse(parsedData.root || parsedData)
        return plainText.trim() // Return the extracted plain text
    } catch (error) {
        // If input is not valid JSON, return it as plain text
        return input
    }
}

const isValidRichText = (str) => {
    if (str != "\"undefined\"") {
        if (str !== null || typeof str !== "undefined" || typeof str !== "number") {
            try {
                JSON.parse(str)
            } catch (e) {
                return false
            }
            return true
        }
        return false
    }
    return false

}

const sasToken = () => {
    let token = ""
    console.log("sas env=>", process.env)
    if (LOCATION_HOST === "qa") {
        token = process.env.REACT_APP_QA_SAS_TOKEN
    }
    if (LOCATION_HOST === "uat") {
        token = process.env.REACT_APP_UAT_SAS_TOKEN
    }
    if (LOCATION_HOST === "ops") {
        token = process.env.REACT_APP_OPS_SAS_TOKEN
    }
    return token
}

const pingRedirectURL = () => {
    let url = ""
    if (LOCATION_HOST === "qa") {
        url = "https://qa.aftersales365.pg.com/home"
    } else if (LOCATION_HOST === "uat") {
        url = "https://uat.aftersales365.pg.com/home"
    } else if (LOCATION_HOST === "dev") {
        url = "https://dev.aftersales365.pg.com/home"
    } else if (LOCATION_HOST === "ops") {
        url = "https://ops.aftersales365.pg.com/home"
    } else if (LOCATION_HOST === "aftersales365") {
        url = "https://aftersales365.pg.com/home"
    } else {
        url = "http://localhost:3000/home"
    }
    return url
}

// thumbnail image load function
const pickLoadableThumbNail = async (id, url, isPartNo, isSampleCollection, isTypeImage) => {
    if (url === null || url === "") {
        return IMAGE_NOT_AVAILABLE
    }
    const urlArr = url?.split(",")
    const img = new Image()
    let pickedUrl = null

    for (const element of urlArr) {
        if (isSampleCollection) {
           img.src = isTypeImage === 1 ? `${TYPE_NO_IMAGE_URL}thumbnail_images/${element}` : 
           `${SAMPLE_COLLECTION_IMAGE_URL}${id}/thumbnail/${element}`
        } else {
            img.src = `${isPartNo ? PART_NO_IMAGE_URL : TYPE_NO_IMAGE_URL}thumbnail_images/${element}`
        }
        pickedUrl = img.src
    }
    return pickedUrl
}
// big image load function
const pickLoadableProductBigImage = async (id, url, isPartNo, isSampleCollection, isTypeImage) => {
    if (url === null || url === "") {
        return IMAGE_NOT_AVAILABLE
    }
    const urlArr = url?.split(",")
    const img = new Image()
    let pickedUrl = null

    for (const element of urlArr) {
        if (isSampleCollection) {
            img.src = isTypeImage === 1 ? `${TYPE_NO_IMAGE_URL}big_images/${element}` : 
            `${SAMPLE_COLLECTION_IMAGE_URL}${id}/product_image/${element}`
        } else {
            img.src = `${isPartNo ? PART_NO_IMAGE_URL : TYPE_NO_IMAGE_URL}big_images/${element}`
        }
        pickedUrl = img.src
    }
    return pickedUrl
}

export const isObjectEmpty = (obj) => {
    return Object.values(obj).every(value =>
        value === "" || value === null || value === undefined ||
        (Array.isArray(value) && value.length === 0)
    )
}

export const removeSpaceFromText = (value) => {
    if (value) {
        return value?.replace(/\s+/g, "")
    }
    return ""
}

export const getExternalUserDataBasedOnCountry = (languageData, userCountryDetails, filterBasedOnId = false) => {

    if (userCountryDetails?.length == 0 || !userCountryDetails) {
        if (sessionStorage?.getItem("countryDetails")) {
            userCountryDetails = JSON.parse(sessionStorage?.getItem("countryDetails"))
        }
    }


    if (userCountryDetails) {
        let countryDetail = userCountryDetails
        const finalLanguageData = languageData?.filter(language => {
            let languageValue
            if (filterBasedOnId) {
                languageValue = language?.id?.toString()
            } else {
                languageValue = language?.value?.toString()
            }

            if (countryDetail?.[0]?.language_id) {
                let splitString = countryDetail?.[0]?.language_id?.split(",")
                if (splitString?.includes(languageValue) || languageValue == "12") {
                    if (language) {
                        return language
                    }

                }
            }

        })
        return finalLanguageData
    }
}

function isISODate(dateString) {
    // Regular expression to match ISO 8601 date format
    const isoFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[\+\-]\d{2}:\d{2})$/

    return isoFormat.test(dateString)
}

const getFormattedDateTime = (isoTimestamp, displayDate, convertDate) =>{
    const utcDate = new Date(isoTimestamp)
    let formattedDateTime
    if (displayDate) {
        formattedDateTime = format(utcDate, `${convertDate}`)
    } else {
        formattedDateTime = format(utcDate, `${convertDate} 'at' HH:mm`)
    }

    return formattedDateTime
}

const getDateOrTimeByValue = (isoTimestamp, displayDate, convertDate) =>{
    if (new Date(isoTimestamp) != "Invalid Date") {
        if (displayDate) {
            return format(new Date(isoTimestamp), `${convertDate}`)
        }
        else {
            return format(new Date(isoTimestamp), `${convertDate}'at' HH:mm`)

        }
    }else{
        if (displayDate) {
            let rangeError = new Date(parseDate(isoTimestamp))
            if(rangeError != "Invalid Date") {
                return format(new Date(parseDate(isoTimestamp)), `${convertDate}`)
            }
        }
        else {
            return format(new Date(parseDate(isoTimestamp)), `${convertDate}'at' HH:mm`)

        }
    }
}

const convertDateTimeByFormat = (isoTimestamp, displayDate) => {
    let dateFormat = ""
    if (sessionStorage?.getItem("countryDetails")) {
        let countryDetail = JSON.parse(sessionStorage?.getItem("countryDetails"))
        dateFormat = countryDetail?.[0]?.date_format
    }

    if (!isoTimestamp) {
        return isoTimestamp
    }
    else {

        let convertDate = sessionStorage.getItem("dateFormatBasedOnCountry")
        if (!convertDate) {
            convertDate = getDateFormat(dateFormat)
        }
        if (isISODate(isoTimestamp)) {
            const formattedDateTime = getFormattedDateTime(isoTimestamp, displayDate, convertDate)
            return formattedDateTime
        }
        else {
            return getDateOrTimeByValue(isoTimestamp, displayDate, convertDate)
        }
    }
}

export const getDateFormat = (dateFormat) => {
    let convertDate = ""
    if (dateFormat)
        dateFormat = dateFormat?.replace(/\s/g, "")?.toLocaleLowerCase()

    if (dateFormat == mdy_dateFormat) {
        convertDate = "MM/dd/yy"
    } else if (dateFormat == dmy_dateFormat) {
        convertDate = "dd/MM/yy"
    } else if (dateFormat == ymd_dateFormat) {
        convertDate = "yy/MM/dd"
    } else if (dateFormat == jul_dateFormat) {
        convertDate = "yy/ddd"
    } else if (dateFormat == iso_dateFormat) {
        convertDate = "yyyy-MM-dd"
    } else if (dateFormat == usa_dateFormat) {
        convertDate = "MM/dd/yyyy"
    } else if (dateFormat == eur_dateFormat) {
        convertDate = "dd.MM.yyyy"
    } else {
        convertDate = "yyyy/MM/dd"
    }
    return convertDate
}

export const formatPrice = (value, qty=false) => {
    if ( value === null || value === "") return value
    let thousandFormat = "."
    let decimalFormat = ","
   
    const countryDetail = JSON.parse(sessionStorage?.getItem("countryDetails"))
    if (countryDetail && countryDetail.length > 0 && countryDetail[0]) {
        thousandFormat = countryDetail[0].thousand_separator || "."
        decimalFormat = countryDetail[0].decimal_separator || ","
    }
    // Ensure it's a number
    const numberValue = value == (0 || "0.00" || "0") ? "0.00" : value
    if (isNaN(numberValue)) return value
    
    // Additional safety: limit input length to prevent any potential issues
    const stringValue = numberValue.toString()
    if (stringValue.length > 20) {
        console.warn("formatPrice: Input value too long")
        return value
    }
    
    // Split into integer and decimal
    const [whole, decimal] = stringValue.split(".")
    
    // Safe regex pattern - avoids nested quantifiers that SonarQube flags
    // Uses explicit end anchor to prevent backtracking issues
    const formattedWhole = whole.replace(/(\d)(?=(\d{3})+$)/g, `$1${thousandFormat}`)
    
    // Alternative non-regex approach (uncomment if you want to avoid regex completely):
    // let formattedWhole = whole
    // for (let i = whole.length - 3; i > 0; i -= 3) {
    //     formattedWhole = formattedWhole.slice(0, i) + thousandFormat + formattedWhole.slice(i)
    // }

    if (qty) {
        return formattedWhole; // return without decimal part
    }
    // Combine with decimal using dynamic separator
    const formattedPrice = decimal
    ? decimal.length > 2
        ? `${formattedWhole}${decimalFormat}${decimal}`
        : `${formattedWhole}${decimalFormat}${decimal.padEnd(2, "0")}`
    : `${formattedWhole}${decimalFormat}00`;
    return formattedPrice;
}


export const formatPriceWithComma = (input) => {
    let formattedInput = input?.toString()
    if (!input) return 0

    let thousandFormat
    let decimalFormat
    const countryDetail = JSON.parse(sessionStorage?.getItem("countryDetails"))

    if (countryDetail && countryDetail.length > 0) {
        thousandFormat = countryDetail?.[0]?.thousand_separator 
        decimalFormat = countryDetail?.[0]?.decimal_separator

        // Replace all occurrences of the thousand separator
        const thousandSeparatorRegex = new RegExp(`\\${thousandFormat}`, "g")
        if(formattedInput?.includes(thousandFormat)) {
            formattedInput = formattedInput?.replace(thousandSeparatorRegex, "")
        }
        // Replace the decimal separator with a dot (.)
        if (decimalFormat !== ".") {
            const decimalSeparatorRegex = new RegExp(`\\${decimalFormat}`, "g")
            formattedInput = formattedInput?.replace(decimalSeparatorRegex, ".")
        }
    }

    // Parse the normalized string into a float
    const result = parseFloat(formattedInput)

    // Return 0 if parsing fails, otherwise return the result
    return isNaN(result) ? 0 : result
}

/////price slice format function for order module
export const splitPriceTable = (value) => {
    const splitPrice = value?.length > 1 ?  value?.split(" ") : []
    const currencyCode = splitPrice?.[0]
    return `${currencyCode} ${ formatPrice(splitPrice?.[1])}`
}

export const formatPriceTolocale = (value) => {
    if (value == 0) {
        return 0
    }
    if (value) {
        let formatted = parseFloat(value).toLocaleString("hi-IN", {
            maximumFractionDigits: 20,
            minimumFractionDigits: 2
        })
        if (formatted?.includes(".00"))
            formatted = formatted?.replace(".00", "")

        return formatted
    } else {
        return ""
    }
}

// Reusable function to generate options
const generateOptions = (data, key) => {
    return data && Array.isArray(data[key]) ?
        data[key].map((item, index) => ({
            label: item, // Use the value as label
            value: item || `value-${index}` // Use item or a fallback value
        }))
        : []
}

// Loged-in Data

const userLoginData = () => {
    const userDetails = sessionStorage.getItem("userDetails")
    return userDetails
        ? JSON.parse(userDetails)?.user_details
        : {}
}

const userTokenData = () => {
    const loginDetails = sessionStorage.getItem("loginDetails")
    return loginDetails
        ? JSON.parse(loginDetails)?.mfaTokenData?.access_token
        : {}
}

// Service Center Details check if we have warranty then they can perofrm any action
const serviceCenterDetails =()=>{
    const loggedInUserDetails = userLoginData()
    return loggedInUserDetails?.service_center_details?.find((record)=>{
        return record.function.includes("warranty")
    })
}

// Sales ORG for internaUser Login
const salesOrgDataForUser =()=>{
    const userDetails = userLoginData()
    const userDetailsSalesOrg = userDetails?.salesOrgs?.filter((record)=>{
        return record?.function?.includes("Warranty")
    })
    return userDetailsSalesOrg?.length ? userDetailsSalesOrg?.map(sale => sale?.org_code).join(", ") : ""

}

//To generate specified length of digit renadom number
const generateRandomNumber = (digitCount) => {
    if (digitCount <= 0) {
        throw new Error("Digit count must be greater than 0")
    }
    const min = Math.pow(10, digitCount - 1) // Minimum value for the digit count (e.g., 1000 for 4 digits)
    const max = Math.pow(10, digitCount) - 1 // Maximum value for the digit count (e.g., 9999 for 4 digits)
    const array = new Uint32Array(1)
    window.crypto.getRandomValues(array)
    // Generate the random number within the range
    const randomNumber = min + (array[0] % (max - min + 1))
    return randomNumber
}

const sanitizeFormData = (formData) => {
    const sanitizedData = { ...formData }
    Object.keys(sanitizedData).forEach((key) => {
        if (typeof sanitizedData[key] === "string") {
            sanitizedData[key] = DOMPurify.sanitize(sanitizedData[key], { ALLOWED_TAGS: [], ALLOWED_ATTR: [] })
        }
    })
    return sanitizedData
}
/**
 * 
 * @param {String} messageID // Message Code
 * @param {String} defaultMessage // Default Message
 * @returns 
 */
const customNotification = (messageID, t) => {
    if(!t) {
        return messageID
    }
    // check if message code have dyanamic value 
    const hasDashValue = messageID?.includes("-")
    let messageCode = hasDashValue ? messageID?.split("-") : messageID
    const isMessage = isMessageCodeExist(hasDashValue ? messageCode[0] : messageCode) || false
    return isMessage ? messageRender(hasDashValue, messageCode, t) : messageID
}
// check if message code exist
const isMessageCodeExist = (messageCode) => {
    let matchMessageCode = {}
    matchMessageCode = messageCodes.find((code)=>{
        return code?.id === messageCode
    })

    return matchMessageCode && Object.keys(matchMessageCode).length
}
// if have dyanamic value then return local message + dyanamic value else only return message 
const messageRender =(hasDashValue, messageCode, t)=>{
    const message = t(`APIMessage.${hasDashValue ? messageCode[0] : messageCode}`)
    return hasDashValue ? `${message} ${messageCode[1]}` : message
}


//function to get fileformat from url

const getFileType = (url) => {
    if(!url) return null
    const extension = url.split(".").pop().toLowerCase()  
    if (["mp4", "mov", "avi", "webm"].includes(extension)) return "video"
    if (["pdf"].includes(extension)) return "pdf"
    if (["zip", "rar"].includes(extension)) return "zip"
    if (["xls", "xlsx", "csv"].includes(extension)) return "excel"
    if (["exe"].includes(extension)) return "exe"
    if (["jpg", "jpeg", "png", "gif", "tif", "tiff", "bmp", "svg",  "webp", "heic", "heif", "raw"].includes(extension)) return "image"
    return "other"
}

const considerOnlyDate=(isoDate,requiredFormat)=>{
    let convertDate = requiredFormat || sessionStorage?.getItem("dateFormatBasedOnCountry")
    const datePart = isoDate?.split("T")[0]
    return format((new Date(datePart)), `${convertDate}`)
}

export {
    buildErrorMessage,
    capitalizeEachLetter,
    capitalizeFirstLetter,
    convertDate,
    convertDateTime,
    convertDateTimeByFormat, convertDateToDDMMYYYY,
    customNotification,
    extractPlainText,
    formatDate,
    generateOptions,
    generateRandomNumber,
    getActivityIdByPathname,
    getFileType,
    getInternalUser,
    considerOnlyDate,
    getLocalDate,
    getTranslateByPathname,
    getUploadByPathname,
    getUserDetails,
    getUserFunctionsArray,
    getUserServiceCenterDetails,
    isMessageCodeExist,
    isValidRichText,
    isValidURL,
    messageRender,
    orderCheckInFunction,
    parseDate,
    pickLoadableProductBigImage,
    pickLoadableThumbNail,
    pingRedirectURL,
    salesOrgDataForUser,
    sanitizeFormData,
    sasToken,
    scrollToError,
    serviceCenterDetails,
    sortData,
    textLineClamp,
    userLoginData,
    userTokenData }
